<h1 class="title">Site & Project Grouping</h1>
<h5>Manage common sites or projects</h5>
<div class="heading w-100">
    <p-tabView orientation="right">
        <p-tabPanel header="Sites">
            <ng-template pTemplate="content">
                <acabim-admin-groups-sites></acabim-admin-groups-sites>
            </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Projects">
            <ng-template pTemplate="content">
                <acabim-admin-groups-projects></acabim-admin-groups-projects>
            </ng-template>
        </p-tabPanel>
    </p-tabView>
</div>
